/**
 * @(#)2019/6/10.
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import Less from "./index.less";
import ReactDOM from "react-dom";
import { get, merge } from "../../utils";
import { Typography, Tooltip } from "antd";
import React, { cloneElement } from "react";
import { omit } from "lodash";

/*
 * YxText的公共部分
 * @param textType {String} 文本控件的类型   文本/标题/段落 Text/Title/Paragraph
 * @param tooltipParam {Object} 气泡组件的参数，参考antd
 * @return {ReactNode}
 * */
let defaul = () => {
  return {
    textType: "Text", //Text/Title/Paragraph
    tooltipParam: {
      //气泡组件的参数
      isTooltip: true, //是否启用气泡
    },
  };
};
export default class Basics {
  static html(tmpProps) {
    let html = "";
    tmpProps = { ...merge(defaul(), { ...tmpProps }) };
    let list = (props) => {
      let setProps = omit(props, ["textType", "tooltipParam"]);
      return {
        Text: <Typography.Text {...setProps} />,
        Title: <Typography.Title {...setProps} />,
        Paragraph: <Typography.Paragraph {...setProps} />,
      }[props.textType];
    };
    //是否启用气泡功能
    let title = get(tmpProps, ["tooltipParam.title", "children"], null);
    let isTooltip = get(tmpProps, "tooltipParam.isTooltip", false);
    if (isTooltip && typeof title === "string") {
      html = (
        <Tooltip key={tmpProps.key} {...tmpProps.tooltipParam} title={title}>
          {list(tmpProps)}
        </Tooltip>
      );
    } else {
      html = list(tmpProps);
    }
    return html;
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Basics.js